<template>
  <v-card class="mx-4 mt-4">
    <v-row align-content="space-between">
      <v-col cols="6">
        <v-card-title class="font-weight-bold"
          >{{ 'Fluxo' }} {{ index + 1 }}</v-card-title
        >
      </v-col>

      <v-col cols="6">
        <v-card-actions v-if="isDev" class="d-flex justify-end">
          <EditFluxo
            @fluxo-editado="(id) => this.$emit('fluxoEditado', id)"
            class="mt-4"
            :id="fluxo.id_fluxo_caso_de_uso"
          />
          <DeleteFluxo
            v-if="fluxo.tipo_fluxo != 'PRINCIPAL'"
            @fluxo-removido="(id) => this.$emit('fluxoRemovido', id)"
            :id="fluxo.id_fluxo_caso_de_uso"
          />
        </v-card-actions>
      </v-col>
    </v-row>

    <v-card-subtitle class="mb-2">
      Tipo de Fluxo:
      <span class="font-weight-bold mr-2">{{ fluxo.tipo_fluxo }}</span>
    </v-card-subtitle>

    <v-card-text class="mt-10">
      <div class="text-h6 mb-4">Descrição</div>
      {{ fluxo.descricao }}
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * @module FluxoCasoUso
 * @desc Fluxo do Caso de Uso.
 */
/* eslint-disable */
import axios from 'axios';
import store from '../store/store';
import EditFluxo from './dialogs/EditFluxo.vue';
import DeleteFluxo from './dialogs/DeleteFluxo.vue';
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    fluxo: Object,
    index: Number,
  },
  components: {
    EditFluxo,
    DeleteFluxo,
  },
  computed: {
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
  },
  methods: {
    /**
     * Exclui o fluxo do CSU.
     *
     * @param {Number} id O id do fluxo
     */
    async deleteFluxo(id) {
      try {
        const response = await axios.delete(
          `${apiUrl}}/api/v1/fluxoCasoUso/${id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          }
        );
      } catch (error) {
        console.log(error);
      }
      location.reload();
    },
  },
};
</script>
